import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';
import * as ContactActions from 'web-app/react/entities/contacts/actions';

import * as Actions from './actions';

export interface EmployeeContactsState {
    readonly didFetchData: boolean;
    readonly fetching: boolean;
    readonly selectedIndex: number | undefined;
}

export class EmployeeContactsReducer extends Record<EmployeeContactsState>({
    didFetchData: false,
    fetching: false,
    selectedIndex: undefined,
}) {}

export default makeReducer<EmployeeContactsReducer>(
    [
        match(ContactActions.fetchEmployeeContacts, state => state.merge({fetching: true, didFetchData: false})),
        match(ContactActions.fetchEmployeeContactsSuccess, state => state.merge({fetching: false, didFetchData: true})),
        match(ContactActions.fetchEmployeeContactsFailed, state => state.merge({fetching: false})),
        match(ContactActions.deleteEmployeeContactSuccess, state => state.merge({selectedIndex: undefined})),
        match(Actions.changeSelectedEmployeeContact, (state, {payload}) => state.merge({selectedIndex: payload})),
    ],
    new EmployeeContactsReducer(),
);
